import { getRequest, patchRequest, postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getRequiredDocumentsRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.documents.requiredDocuments, {
      ApplicationUid,
    }),
  );

export const getSocureCaptureRequest = ({ ApplicationUid, data, params }) =>
  getRequest(
    replaceInUrl(apiEndpoints.documents.documents, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const socureDocumentsUploadRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.documents.documents, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const socureVerificationExecutionRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  patchRequest(
    replaceInUrl(apiEndpoints.documents.documents, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const socureEventRequest = ({ data }) =>
  postRequest(replaceInUrl(apiEndpoints.documents.socureEvent, data));
